import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import store from 'store/store';
import Menu from './Menu'
import * as IconsBi from "react-icons/bi";
import logoIcon from 'assets/images/logo-icon.png'
import { Status, threePoint, dictionary } from 'components/common/Config'


function Sidebar(props) {
    const state = store.getState()

	// let navigate = useNavigate();
	// let location = useLocation();
	// // console.log('props:',props)
	// console.log('location:',location)
	// // console.log('navigate:',navigate)

	// useEffect(() => {
	// 	console.log('useEffect - navigate:',navigate)
    //     callParentSidebarToggle()
    // }, [navigate])
	
    const callParentSidebarToggle = () => {
        props.sidebarToggle()
    }

    return (
        <div className="sidebar-wrapper" data-simplebar="true">
			<div className="sidebar-header">
				<div>
					<img src={logoIcon} className="logo-icon" alt="logo icon" />
				</div>
				<div>
					{
						dictionary['base-'+dictionary.app].sidebarName?.length > 14
						?
						<h5 className="logo-text" style={{fontSize:'16px'}}>{dictionary['base-'+dictionary.app].sidebarName}</h5>
						:
						<h4 className="logo-text">{dictionary['base-'+dictionary.app].sidebarName}</h4>
					}
				</div>
				<div className="toggle-icon ms-auto" onClick={callParentSidebarToggle}>
                    <IconsBi.BiChevronsRight />
				</div>
			</div>

            <Menu user={state?.user} style={{paddingBottom:'30px'}} {...props} />

			<div className="sidebar-footer">
				<p className="mb-0 text-center" style={{lineHeight:'30px', fontSize:'12px'}}>
					<span>مدیریت فنی و فناوری اطلاعات</span>
					<span> &#169; {new Date().toLocaleDateString('fa-IR', {year: 'numeric'})}</span>
				</p>
			</div>
		</div>
    )
}

export default Sidebar;